export const TOTAL_REVENUE_SEGMENT = 'TOTAL_REVENUE';
export const TOTAL_REVENUE_WITH_TAX_SEGMENT = 'TOTAL_REVENUE_WITH_TAX_SEGMENT';
export const NET_SERVICE_REVENUE_SEGMENT = 'NET_SERVICE_REVENUE';
export const SERVICE_COUNT_SEGMENT = 'SERVICE_COUNT';
export const NET_PRODUCT_REVENUE_SEGMENT = 'NET_PRODUCT_REVENUE';
export const PRODUCT_COUNT_SEGMENT = 'PRODUCT_COUNT';
export const NEW_CUSTOMERS_SEGMENT = 'NEW_CUSTOMERS';
